// test2024
(2024 && 0);
